export const matomoPush = (args) => {
  if (typeof window === 'undefined') return;

  window._paq = window._paq || [];
  window._paq.push(args);
};

export const trackEvent = (category, action, name, value) => {
  matomoPush(['trackEvent', category, action, name, value].filter((arg) => arg !== undefined));
};

export const trackEcommerceCart = (items, total) => {
  matomoPush(['clearEcommerceCart']);

  items.forEach((item) => {
    const product = item.matomo;
    matomoPush([
      'addEcommerceItem',
      product.sku,
      product.name,
      product.category,
      product.price,
      product.quantity
    ]);
  });

  matomoPush(['trackEcommerceCartUpdate', total]);
};
